import { Slider } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CustomSlider = styled(Slider)(({ theme }) => ({
  color: theme.colors["lime.600"],

  "& .MuiSlider-thumb": {
    backgroundColor: "#fff",
  },
  "& .MuiSlider-valueLabel": {
    backgroundColor: "unset",
    color: theme.palette.text.primary,
    "& *": {
      background: "transparent",
      color: "#000",
    },
  },
  "& .MuiSlider-rail": {
    opacity: 0.5,
    backgroundColor: "#d0d0d0",
  },
}));

export const SliderContainer = styled("div")(({ theme }) => ({
  height: "85px",
  width: "fit-content",
  display: "flex",
  marginLeft: "auto",
  flexDirection: "column",
  gap: "8px",
  alignItems: "end",
 
}));
